"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _StepLabel = _interopRequireDefault(require("../../StepLabel"));
var _excluded = ["className", "light", "disabled", "isStatic"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "stepLabel": "RcwkVn",
  "isStatic": "_3U0cm0",
  "light": "Yxf9Rd",
  "disabled": "xq76Yp",
  "default": "qW9qm7",
  "noStatic": "-lTRFw"
};
var getClassName = function getClassName(_ref) {
  var className = _ref.className,
    light = _ref.light,
    disabled = _ref.disabled,
    isStatic = _ref.isStatic;
  return (0, _clsx["default"])(className, styles.stepLabel, isStatic && styles.isStatic, !isStatic && styles.noStatic, light && styles.light, disabled && styles.disabled, !light && !disabled && styles["default"]);
};
var StepLabel = function StepLabel(_ref2) {
  var className = _ref2.className,
    light = _ref2.light,
    disabled = _ref2.disabled,
    isStatic = _ref2.isStatic,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StepLabel["default"], _extends({
    className: getClassName({
      className: className,
      light: light,
      disabled: disabled,
      isStatic: isStatic
    })
  }, props));
};
StepLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  isStatic: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  light: _propTypes["default"].bool
} : {};
var _default = exports["default"] = StepLabel;